import React from 'react';
import { StyledDeviceText } from '../styledComponents';
import { toNumber } from 'utils/helpers';

class DeviceText extends React.PureComponent {
  state = {
    fontShrink: 1,
  };

  componentDidMount() {
    this.calcFontSize();
  }

  componentDidUpdate(nextProps) {
    if (this.props.children !== nextProps.children) {
      this.calcFontSize();
    }
  }

  calcFontSize = () => {
    const { domNodeShadow } = this;
    const fontShrink =
      !!domNodeShadow && domNodeShadow.scrollWidth > domNodeShadow.clientWidth
        ? domNodeShadow.clientWidth/(domNodeShadow.scrollWidth+30)
        : 1;

    this.setState({
      fontShrink,
    });
    this.props.onShrinkChange && this.props.onShrinkChange(this.props.name, fontShrink);
  }

  render() {
    const {
      font,
      base,
      maxFontWidth,
      children,
      lineHeight,
      letterSpacing,
    } = this.props;
    const shrinkBy = 0.16024;
    const maxWidth = ((maxFontWidth || 1300) - 1) * shrinkBy;
    const baseSize = base * shrinkBy;
    const { fontShrink } = this.state;
    const fontSize = fontShrink * baseSize;
    const fontSizeShadow = 1 * baseSize;

    const prepareFont = (font) => {
      if(font === 'Proxima Nova') {
        return {
          font: 'proxima-nova'
        }
      } else {
        return {}
      }
    }

    const presentationalProps = Object.assign({}, {
      font,
      maxWidth,
      fontSize,
      children,
      lineHeight,
      letterSpacing: toNumber(letterSpacing) * (shrinkBy*fontShrink ),
    }, prepareFont(font));

    const presentationalPropsShadow = {
      ...presentationalProps,
      fontSize: fontSizeShadow
    };

    return (
      <div>
        <StyledDeviceText
          innerRef={ref => { this.domNode = ref; }}
          {...presentationalProps}
        />
        <StyledDeviceText
          innerRef={ref => { this.domNodeShadow = ref; }}
          {...presentationalPropsShadow}
          style={{opacity: 0, position: 'absolute', zIndex: -1}}
        />
      </div>
    );
  }
}

export default DeviceText;
